import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';

function Stocklist() {
  const { user } = useUser();
  const [allstocking, setAllstocking] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchmyStockes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setAllstocking(data.mystocks);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);

  //COMPONENT ATTACHMENTS
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Stock" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Stock" icon={<FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="mycard mt-2">
                    {allstocking.length > 0 ? (
                    <div className="table-responsive scrollDown">
                        <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
                            <thead>
                                <tr className="fs-7">
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th className="text-nowrap">Purchase Price</th>
                                    <th>Amount</th>
                                    <th className="text-nowrap">Invetment Date</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody style={{fontSize: '14px'}}>
                            {allstocking.map((stocking, key) => (
                            <tr key={key}>
                                <td>{key + 1}</td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <img 
                                        src={`https://images.financialmodelingprep.com/symbol/${stocking.symbol}.png`} 
                                        alt={stocking.name} 
                                        style={{ width: '25px', height: '25px', borderRadius: '50%', marginRight: '8px' }} 
                                        />
                                        <div className="ms-2">
                                            <p className="lh-1 mb-0 fw-bold">{stocking.name}</p>
                                            <p className="lh-1 mb-0" style={{color:'gray'}}>{stocking.symbol}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>{getCurrencySymbol(user?.currency)}{formatCurrency(stocking.pur_price * rate)}</td>
                                <td className="text-success fw-bold">{getCurrencySymbol(user?.currency)}{formatCurrency(stocking.amount * rate)} ~ {formatCurrency(stocking.amount/stocking.pur_price)} {stocking.symbol}</td>
                                <td className="text-nowrap">{stocking.date}</td>
                                 <td style={{color: stocking.status === 'active' ? 'green' : stocking.status === 'pending' ? 'orange' : 'red'}}>{stocking.status === 'active' ? 'Active' :stocking.status === 'pending' ? 'Pending' : 'Closed'}</td>
                            </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    ) : (
                    <div className="d-flex align-items-center flex-column justify-content-center w-100 h-100" style={{gap: '16px', color: 'rgba(255, 255, 255, 0.65)'}}>
                        <svg style={{width: '40px', height: '40px'}} className="svg-icon" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.132 6.06h10" stroke="currentColor" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path><path d="M14.352 2.5h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V4.7c0-1.76.44-2.2 2.22-2.2Z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"></path><path d="M2.132 17.56h10" stroke="currentColor" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path><path d="M4.352 14h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V16.2c0-1.76.44-2.2 2.22-2.2ZM22.132 15.5c0 3.87-3.13 7-7 7l1.05-1.75" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"></path><path d="M7.05 4.1 3.738 7.414M3.732 4.1l3.314 3.314" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"></path></svg>
                        <p className=" mb-0 fw-semibold">No stock investment yet.</p>
                    </div>
                    )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Stocklist